const { responsiveFontSizes } = require("@mui/material/styles");
const { createTheme } = require("@mui/material");

const themeOptions = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: '#A5ADBA', //Gray
        magBlue: '#37516D', //Mag blue
        navyBlue: '#253858', //Navy blue
      },
      secondary: {
        main: '#7c9cbd', //Muted-Light Blue; hover color
        alert: '#f08080', //light coral
        submit: '#65d24d',  //light green
        submit2:'#95e483',  //Hover for submit
        tooltip: '#6391dd', //light blue
      },
      background: {
        default: '#DFE1E6', //light gray
        paper: '#ffffff', //off-white
        rowWhite: '#e1e1e1',
      },
      text: {
        primary: "#2a2a2a", //Near-black
        secondary: "#ffffff", // White
        contrast: "#626262", //Dark Gray
      },
    },

    typography: {
      fontFamily: [].join(","),
      h2: { fontWeight: 500 },
      h4: { fontWeight: 500 },
    },
  })
);

const theme = createTheme(themeOptions, {
})

theme.spacingValue = theme.spacing(1);

module.exports = theme;